/**
 *@format
 */
import { api } from '@/scripts/api';

export const MDFAgencyManagersService = {
    getAll({ accountId, config = '' }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/partner-managers/account/${accountId}/managers?${config}`;
            api.get(service).then(resolve).catch(reject);
        });
    },
    getAllManagers({ accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/partner-managers/account/${accountId}/accountManagers`;
            api.get(service).then(resolve).catch(reject);
        });
    },
};
